// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.requestsHub {
  min-height: 100%;
  padding: 0 4px 40px;
  background: var(--surface-page, #f6f8fb);
  color: var(--text-body, #334155);
}

.requestsHub-topbar {
  min-height: 38px;
  margin: -22px -24px 18px;
  padding: 0 24px;
  border-bottom: 1px solid var(--border-subtle, #dbe4ee);
  background: var(--surface-card, #ffffff);
  display: flex;
  align-items: center;
}

.requestsHub-head {
  min-height: 70px;
  width: calc(100% + 56px);
  margin: -20px 0 18px -28px;
  padding: 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  display: flex;
  align-items: center;
  gap: 28px;
}

.requestsHub-breadcrumb {
  margin-bottom: 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 650;
}

.requestsHub h1 {
  margin: 0;
  color: var(--text-heading, #0f172a);
  font-family: var(--font-display, var(--font-body, system-ui, sans-serif));
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.015em;
  white-space: nowrap;
  line-height: 1.15;
}

.requestsHub p {
  max-width: 680px;
  margin: 8px 0 18px;
  color: var(--text-muted, #64748b);
  font-size: var(--text-sm, 13px);
  line-height: 1.55;
  font-weight: 400;
}

.requestsHub-tabs {
  min-width: 0;
  margin: 0;
  border: 0;
  flex: 1;
  display: flex;
  align-self: stretch;
  align-items: center;
  gap: 26px;
  overflow-x: auto;
}

.requestsHub-tab {
  min-height: 70px;
  padding: 24px 0 23px;
  border-bottom: 3px solid transparent;
  color: var(--text-muted, #64748b);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 650;
  white-space: nowrap;
  text-decoration: none;
}

.requestsHub-tab:hover {
  color: var(--brand-primary, #227ebd);
  text-decoration: none;
}

.requestsHub-tab--active {
  border-bottom-color: var(--blue-500, #227ebd);
  color: var(--blue-600, #1a6da3);
}

.requestsHub-tab b {
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: var(--radius-pill, 999px);
  background: var(--slate-100, #eef2f6);
  color: currentColor;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 850;
  line-height: 1;
}

.requestsHub-tab--active b {
  background: #e8f2fb;
  color: var(--brand-primary, #227ebd);
}

.requestsHub-content > .mt-3 {
  margin-top: 0 !important;
}

.requestsHub-content .requests-modernScreen {
  gap: 12px;
  padding: 12px 16px 0;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.requestsHub-content .requests-tableCard,
.requestsHub-content .requests-empty {
  border-right: 0;
  border-left: 0;
  border-bottom: 0;
  border-radius: 0;
}

.requestsHub-content .people-pagination {
  margin: 0 -16px;
  padding: 12px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.requestsHub-content .row {
  margin-left: 0;
  margin-right: 0;
}

.requestsHub-content .col-md-12 {
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 720px) {
  .requestsHub {
    padding: 0 4px 32px;
  }

  .requestsHub-head {
    width: 100vw;
    margin: -16px 0 14px -16px;
    padding: 0 14px;
    gap: 18px;
  }

  .requestsHub-tabs {
    gap: 14px;
    overflow-x: auto;
  }

  .requestsHub-tab {
    flex: 0 0 auto;
  }
}

.requests-modernScreen {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.requests-toolbar {
  margin-bottom: 0;
}

.requests-toolbar {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.requests-toolbar__row {
  width: 100%;
  display: flex;
  align-items: center;
}

.requests-toolbar__row--primary {
  justify-content: flex-start;
  gap: 8px;
}

.requests-nameSearch {
  width: min(360px, 100%);
  margin: 0;
  display: block;
}

.requests-nameSearch input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font: 650 13px var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.requests-nameSearch input::placeholder {
  color: var(--text-muted, #64748b);
  font-weight: 400;
  opacity: 1;
}

.requests-nameSearch input:focus {
  outline: none;
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);
}

.requests-toolbar__row--secondary {
  justify-content: flex-start;
}

.requests-toolbar__controls {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.requests-filter {
  margin-top: 0;
  grid-template-columns: repeat(2, minmax(160px, 1fr)) minmax(250px, 1.2fr) auto;
  align-items: end;
  gap: 16px;
  padding: 16px;
  border-color: var(--border-subtle, #dbe3ec);
  background: var(--surface-subtle, #f8fafc);
  box-shadow: none;
  position: relative;
  z-index: 20;
  overflow: visible;
}

.requests-filter .people-filter__field {
  min-width: 150px;
  gap: 7px;
}

.requests-filter .people-filter__field > span,
.requests-dateRange label {
  color: var(--text-body, #334155);
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.requests-filter .people-filter__field input,
.requests-filter .people-filter__field select {
  width: 100%;
  height: 38px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background-color: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 13px;
  font-weight: 650;
}

.requests-filter .people-filter__field select {
  padding-right: 36px;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 11px center;
  cursor: pointer;
}

.requests-filter .people-filter__field input:focus,
.requests-filter .people-filter__field select:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));
}

.requests-dateRange {
  min-width: 250px;
  transform: translateY(-9px);
  position: relative;
  z-index: 30;
}

.requests-dateRange .sit-dp,
.requests-dateRange .sit-dp__pop {
  z-index: 10000;
}

.requests-dateRange .sit-dp__pop {
  position: fixed;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: hidden;
  overscroll-behavior: contain;
  align-items: stretch;
  animation: none;
}

.requests-dateRange .sit-dp__pop > div:last-child {
  min-width: 0;
  min-height: 0;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

.requests-dateRange .sit-dp__pop > div:last-child > div:first-child {
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
}

.requests-dateRange .sit-dp__pop > div:last-child > div:last-child {
  flex: 0 0 auto;
  padding: 0 14px 14px !important;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);
}

.requests-dateRange .sit-cal__foot {
  position: static;
  margin: 0;
  padding-top: 12px;
}

.requests-filter .people-filter__actions {
  min-height: 38px;
  flex-wrap: nowrap;
  transform: translateY(-9px);
}

.requests-filter .people-filter__actions .people-btn {
  height: 38px;
  min-height: 38px;
}

.requests-search {
  display: grid;
  grid-template-columns: repeat(4, minmax(140px, 180px));
  flex: 0 1 auto;
  min-width: 0;
  gap: 8px;
}

.requests-search .people-search__field {
  width: auto;
  min-width: 0;
}

.requests-search .people-search__field:first-child input {
  border-radius: var(--radius-md, 8px);
}

.requests-search .people-search__field:last-child input {
  border-radius: var(--radius-md, 8px);
}

@media (max-width: 900px) {
  .requests-filter {
    grid-template-columns: repeat(2, minmax(160px, 1fr));
  }

  .requests-filter .people-filter__actions {
    transform: none;
  }
}

.requests-selection {
  margin-top: 0;
}

.requests-tableCard {
  margin-top: 0;
}

.requests-table th,
.requests-table td {
  vertical-align: middle;
}

.requests-table th:first-child,
.requests-table td:first-child {
  width: 42px;
}

.requests-table--archive th:first-child,
.requests-table--archive td:first-child {
  width: auto;
}

.requests-table:not(.requests-table--archive).requests-hide-date th:nth-child(2),
.requests-table:not(.requests-table--archive).requests-hide-date td:nth-child(2),
.requests-table:not(.requests-table--archive).requests-hide-requester th:nth-child(3),
.requests-table:not(.requests-table--archive).requests-hide-requester td:nth-child(3),
.requests-table:not(.requests-table--archive).requests-hide-role th:nth-child(4),
.requests-table:not(.requests-table--archive).requests-hide-role td:nth-child(4),
.requests-table:not(.requests-table--archive).requests-hide-phone th:nth-child(5),
.requests-table:not(.requests-table--archive).requests-hide-phone td:nth-child(5),
.requests-table:not(.requests-table--archive).requests-hide-sports th:nth-child(6),
.requests-table:not(.requests-table--archive).requests-hide-sports td:nth-child(6),
.requests-table:not(.requests-table--archive).requests-hide-comment th:nth-child(7),
.requests-table:not(.requests-table--archive).requests-hide-comment td:nth-child(7),
.requests-table--archive.requests-hide-date th:nth-child(1),
.requests-table--archive.requests-hide-date td:nth-child(1),
.requests-table--archive.requests-hide-requester th:nth-child(2),
.requests-table--archive.requests-hide-requester td:nth-child(2),
.requests-table--archive.requests-hide-role th:nth-child(3),
.requests-table--archive.requests-hide-role td:nth-child(3),
.requests-table--archive.requests-hide-email th:nth-child(4),
.requests-table--archive.requests-hide-email td:nth-child(4),
.requests-table--archive.requests-hide-phone th:nth-child(5),
.requests-table--archive.requests-hide-phone td:nth-child(5),
.requests-table--archive.requests-hide-comment th:nth-child(6),
.requests-table--archive.requests-hide-comment td:nth-child(6),
.requests-table--archive.requests-hide-status th:nth-child(7),
.requests-table--archive.requests-hide-status td:nth-child(7) {
  display: none;
}

.requests-dateCell {
  white-space: nowrap;
  color: var(--text-body, #334155);
  font-weight: 650;
}

.requests-personCell {
  min-width: 220px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.requests-avatar {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e8f2fb;
  color: var(--brand-primary, #227ebd);
  display: inline-grid;
  place-items: center;
  flex: 0 0 32px;
  font-size: 11px;
  font-weight: 850;
  line-height: 1;
  overflow: hidden;
  text-align: center;
}

.requests-avatar > span,
.requests-personCell .requests-avatar > span,
.requestAcceptParent__student .requests-avatar > span {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex !important;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transform: none;
  text-align: center;
}
.requests-personCell strong,
.requests-personCell span {
  display: block;
}

.requests-personCell strong {
  color: var(--text-heading, #0f172a);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.2;
}

.requests-personCell div > span {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.requests-roleChip {
  min-height: 24px;
  padding: 0 9px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background: color-mix(in srgb, var(--requests-role-color, #227ebd) 13%, #ffffff);
  color: var(--requests-role-color, #227ebd);
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.requests-filter .people-filter__actions > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.requests-roleChip i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.requests-chipList {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.requests-sportChip,
.requests-moreChip {
  min-height: 22px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  background: var(--slate-100, #eef2f6);
  color: var(--text-body, #334155);
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
}

.requests-moreChip {
  color: var(--text-muted, #64748b);
}

.requests-muted {
  color: var(--text-subtle, #94a3b8);
}

.requests-contactCell,
.requests-contactCell small {
  display: block;
}

.requests-contactCell {
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 650;
}

.requests-contactCell small {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 600;
}

.requests-commentCell {
  max-width: 280px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-body, #334155);
}

.requests-statusBadge {
  min-height: 24px;
  padding: 0 9px;
  border-radius: var(--radius-pill, 999px);
  background: var(--slate-100, #eef2f6);
  color: var(--text-muted, #64748b);
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 800;
}

.requests-statusBadge--accepted {
  background: #e8f7ee;
  color: #268049;
}

.requests-statusBadge--rejected {
  background: #fff4f2;
  color: #b42318;
}

.requests-empty {
  min-height: 260px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #ffffff);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  padding: 32px;
}

.requests-empty__icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #e8f2fb;
  color: var(--brand-primary, #227ebd);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 900;
}

.requests-empty h3 {
  margin: 4px 0 0;
  color: var(--text-heading, #0f172a);
  font-size: 17px;
  font-weight: 850;
}

.requests-empty p {
  margin: 0;
  max-width: 420px;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  font-weight: 550;
}

.requests-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 700;
}

.requests-pagination > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.requests-pagination b {
  color: var(--text-heading, #0f172a);
  font-size: 13px;
  font-weight: 800;
}

.requests-pagination .people-btn:disabled,
.requests-selection .people-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .requests-filter .people-filter__field {
    min-width: 100%;
  }

  .requests-pagination {
    align-items: flex-start;
    flex-direction: column;
  }
}

.requests-avatar--lg {
  width: 44px;
  height: 44px;
  flex-basis: 44px;
  font-size: 14px;
}

.requests-table tbody tr {
  cursor: pointer;
}

.requests-table tbody tr[data-preview='true'] {
  background: #eef8ff;
}

.requests-table tbody tr[data-preview='true'] td:first-child {
  box-shadow: inset 3px 0 0 var(--brand-primary, #227ebd);
}

.requests-drawerScrim {
  position: fixed;
  inset: 0;
  z-index: 1030;
  background: rgba(15, 23, 42, 0.18);
}

.requests-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1031;
  width: min(440px, 100vw);
  background: var(--surface-card, #ffffff);
  box-shadow: -22px 0 48px rgba(15, 23, 42, 0.18);
  display: flex;
  flex-direction: column;
}

.requests-drawer__head {
  padding: 22px 22px 18px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.requests-drawer__identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.requests-drawer__identity h2 {
  margin: 0;
  color: var(--text-heading, #0f172a);
  font-size: 18px;
  font-weight: 850;
  line-height: 1.2;
}

.requests-drawer__identity p {
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 650;
}

.requests-drawer__close {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-subtle, #dbe4ee);
  border-radius: var(--radius-md, 8px);
  background: #ffffff;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
}

.requests-drawer__body {
  padding: 18px 22px;
  overflow: auto;
  flex: 1;
}

.requests-drawerSection {
  padding: 0 0 18px;
  margin-bottom: 18px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.requests-drawerSection:last-child {
  margin-bottom: 0;
}

.requests-drawerSection__title,
.requests-drawerField span {
  margin-bottom: 9px;
  color: var(--text-muted, #64748b);
  display: block;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.requests-drawerField {
  margin-top: 12px;
}

.requests-drawerField strong {
  color: var(--text-heading, #0f172a);
  display: block;
  font-size: 14px;
  font-weight: 750;
  line-height: 1.35;
  word-break: break-word;
}

.requests-drawerMessage {
  padding: 13px 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--slate-25, #fbfdff);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.55;
}

.requests-drawer__foot {
  padding: 14px 18px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: 720px) {
  .requestsHub-topbar {
    margin: -18px -14px 16px;
    padding: 0 14px;
  }
}

.requestActionModal {
  border: 0;
  border-radius: var(--radius-lg, 12px);
  overflow: hidden;
  background: var(--surface-card, #ffffff);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.requestActionModal--embedded {
  margin: -22px -24px;
  box-shadow: none;
}

.requestActionModal__dialog {
  margin: 24px auto;
}

.requestActionModal__head {
  padding: 20px 22px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
}

.requestActionModal__head h5 {
  margin: 0;
  color: var(--text-heading, #0f172a);
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  font-size: 19px;
  font-weight: 850;
  line-height: 1.2;
  letter-spacing: 0;
}

.requestActionModal__head p {
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
}

.requestActionModal__icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md, 8px);
  background: #e8f2fb;
  color: var(--brand-primary, #227ebd);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  line-height: 1;
}

.requestActionModal__icon--warning {
  background: #fff7e8;
  color: #b76b00;
}

.requestActionModal__icon--danger {
  background: #fff1f2;
  color: var(--red-600, #c4313f);
}

.requestActionModal__close {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-subtle, #dbe4ee);
  border-radius: var(--radius-md, 8px);
  background: #ffffff;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  padding: 0;
}

.requestActionModal__body {
  padding: 22px;
  color: var(--text-body, #334155);
  font-size: 14px;
  font-weight: 550;
  line-height: 1.55;
}

.requestActionModal__body p {
  display: block;
  width: 100%;
  max-width: none;
  margin: 0 0 16px;
  color: var(--text-body, #334155);
  font-size: 14px;
  font-weight: 550;
}

.requestActionModal__intro {
  grid-column: 1 / -1;
  align-self: stretch;
}

.requestRejectModal .modal-body {
  padding: 0 !important;
  overflow: hidden !important;
}

.requestRejectModal .requestActionModal--embedded {
  margin: 0;
}

.requestRejectModal .requestActionModal__head {
  padding: 15px 17px;
}

.requestRejectModal .requestActionModal__head h5 {
  font-size: 17px;
}

.requestRejectModal .requestActionModal__head p {
  margin-top: 3px;
  font-size: 12px;
}

.requestRejectModal .requestActionModal__icon {
  width: 34px;
  height: 34px;
}

.requestRejectModal .requestActionModal__body {
  padding: 15px 17px;
}

.requestRejectModal .requestActionModal__notice {
  padding: 11px 12px;
  font-size: 12.5px;
}

.requestRejectModal .requestActionModal__foot {
  padding: 11px 17px;
}

.requestActionModal__identityGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.requestActionModal__identityGrid > div,
.requestActionModal__summaryCard {
  padding: 13px 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--slate-25, #fbfdff);
}

.requestActionModal__identityGrid span,
.requestActionModal__summaryCard span {
  display: block;
  margin-bottom: 5px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.requestActionModal__identityGrid strong,
.requestActionModal__summaryCard strong {
  display: block;
  color: var(--text-heading, #0f172a);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.3;
  word-break: break-word;
}

.requestActionModal__summaryCard small {
  display: block;
  margin-top: 3px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
}

.requestActionModal__summaryArrow {
  margin: 10px 0;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.requestActionModal__notice {
  padding: 13px 14px;
  border: 1px solid #ffe3ad;
  border-radius: var(--radius-md, 8px);
  background: #fffaf0;
  color: #755100;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.5;
}

.requestActionModal__notice--danger {
  border-color: #ffd5da;
  background: #fff5f6;
  color: #9f2430;
}

.requestActionModal__foot,
.requestMergeForm__foot,
.requestAcceptParent__foot {
  padding: 16px 22px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  flex-wrap: wrap;
  background: #fbfdff;
}

.requestMergeForm {
  margin: -22px -24px;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.requestMergeForm__head {
  padding: 20px 22px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  display: flex;
  align-items: center;
  gap: 13px;
}

.requestMergeForm__head h5 {
  margin: 0;
  color: var(--text-heading, #0f172a);
  font-size: 19px;
  font-weight: 850;
  line-height: 1.2;
}

.requestMergeForm__head p {
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 600;
}

.requestMergeForm__grid {
  padding: 18px 22px 0;
  display: grid;
  gap: 12px;
}

.requestMergeForm__grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.requestMergeForm__field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
  margin: 0;
}

.requestMergeForm__field > span {
  color: var(--text-heading, #0f172a);
  font-size: 13px;
  font-weight: 800;
}

.requestMergeForm > .requestMergeForm__field {
  padding: 18px 22px 22px;
}

.requestMergeForm__autocomplete {
  width: 100%;
}

.requestMergeForm__autocomplete input,
.requestAcceptParent .eAutocomplete input {
  min-height: var(--control-h-md, 40px);
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  color: var(--text-heading, #0f172a);
  font-size: 14px;
  font-weight: 600;
}

.requestAcceptParent {
  padding: 24px;
  min-height: 100%;
  background: var(--surface-page, #f6f8fb);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.requestAcceptParent__card {
  max-width: 980px;
  margin: 0 auto;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #ffffff);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.requestAcceptParent__head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  display: flex;
  align-items: center;
  gap: 13px;
}

.requestAcceptParent__head h1 {
  margin: 0;
  color: var(--text-heading, #0f172a);
  font-size: 24px;
  font-weight: 850;
  line-height: 1.15;
}

.requestAcceptParent__head p {
  margin: 5px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  font-weight: 600;
}

.requestAcceptParent__message {
  margin: 18px 24px 0;
  padding: 13px 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: #fbfdff;
}

.requestAcceptParent__message span,
.requestAcceptParent__sectionTitle {
  display: block;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.requestAcceptParent__message strong {
  display: block;
  margin-top: 6px;
  color: var(--text-heading, #0f172a);
  font-size: 14px;
  font-weight: 650;
  line-height: 1.45;
}

.requestAcceptParent__details {
  margin: 18px 24px 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.requestAcceptParent__details > div {
  padding: 12px 13px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: #fbfdff;
}

.requestAcceptParent__details span {
  display: block;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
}

.requestAcceptParent__details strong {
  display: block;
  margin-top: 4px;
  color: var(--text-heading, #0f172a);
  font-size: 13px;
  font-weight: 800;
}

.requestAcceptParent__sectionTitle {
  margin: 20px 24px 10px;
}

.requestAcceptParent__grid {
  margin: 0 24px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.requestAcceptParent__error {
  margin: 14px 24px 0;
  padding: 12px 13px;
  border: 1px solid #ffd5da;
  border-radius: var(--radius-md, 8px);
  background: #fff5f6;
  color: #9f2430;
  font-size: 13px;
  font-weight: 750;
}

.requestAcceptParent__studentGrid {
  margin: 0 24px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.requestAcceptParent__student {
  min-width: 0;
  padding: 10px 11px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: #ffffff;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.requestAcceptParent__student:hover,
.requestAcceptParent__student--selected {
  border-color: var(--border-brand, #6fb1df);
  background: #eef8ff;
  text-decoration: none;
}

.requestAcceptParent__student strong,
.requestAcceptParent__student small {
  display: block;
}

.requestAcceptParent__student strong {
  color: var(--text-heading, #0f172a);
  font-size: 14px;
  font-weight: 800;
}

.requestAcceptParent__student small {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
}

.requestAcceptParent__foot {
  margin-top: 22px;
}

@media (max-width: 780px) {
  .requestActionModal__identityGrid,
  .requestMergeForm__grid--two,
  .requestAcceptParent__details,
  .requestAcceptParent__grid,
  .requestAcceptParent__studentGrid {
    grid-template-columns: 1fr;
  }

  .requestAcceptParent {
    padding: 14px;
  }
}

.requestMergeForm__autocomplete.bAutocomplete,
.requestAcceptParent .requestMergeForm__autocomplete.bAutocomplete {
  display: block;
  width: 100%;
}

.requestMergeForm__autocomplete .eShowDropdownMenu,
.requestAcceptParent .requestMergeForm__autocomplete .eShowDropdownMenu {
  position: static !important;
  float: none;
  transform: none !important;
  width: 100%;
  max-width: none;
  min-width: 0;
  max-height: 220px;
  margin-top: 6px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  overflow-y: auto;
  overflow-x: hidden;
}

.requestAcceptParent__card {
  overflow: visible;
}
/* Role-request lists have few fields, so the handoff uses an anchored popover. */
.requests-modernScreen,
.requests-page {
  position: relative;
}

.requests-filter.people-filter {
  position: fixed;
  z-index: 1050;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  flex-direction: column;
  width: 360px;
  max-width: calc(100vw - 20px);
  height: auto;
  max-height: none;
  align-items: stretch;
  gap: 10px;
  margin: 0;
  padding: 18px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 0;
  border-left: 1px solid #d9e2ec;
  border-radius: 0;
  background: #fff;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.requests-filterScrim {
  position: fixed;
  inset: 0;
  z-index: 1049;
  background: rgba(15, 23, 42, 0.18);
}

.requests-contentLayout {
  min-width: 0;
}

.requests-contentLayout--withFilter {
  display: block;
}

.requests-contentMain {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.requests-filter .people-filter__header {
  margin-bottom: 2px;
}

.requests-filter .requests-dateRange {
  width: 100%;
  min-width: 0;
  transform: none;
}

.requests-filter .people-chipFilter legend {
  margin-bottom: 5px;
}

.requests-filter .people-chipFilter__body {
  max-height: none;
  overflow: visible;
}

.requests-filter .people-chipFilter__chips {
  gap: 5px;
}

.requests-filter .people-chipFilter__chip {
  min-height: 27px;
  padding: 3px 8px;
  font-size: 11px;
}

.requests-filter .people-filter__actions {
  position: static;
  width: auto;
  max-width: none;
  min-height: auto;
  margin: auto 0 0;
  padding: 14px 0 0;
  border-top: 1px solid #e6ebf1;
  transform: none;
  display: flex;
  align-items: center;
  gap: 6px;
}

.requests-filter .people-filter__actions .people-btn {
  height: 38px;
  min-height: 38px;
}

@media (max-width: 640px) {
  .requests-contentLayout--withFilter {
    display: block;
  }

  .requests-filter.people-filter {
    position: fixed;
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    max-height: 86vh;
    overflow-y: auto;
    border-radius: 16px 16px 0 0;
  }

  .requests-toolbar__row--primary {
    align-items: flex-start;
    flex-direction: column;
  }

  .requests-toolbar__row--secondary,
  .requests-search {
    width: 100%;
  }

  .requests-search {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .requests-search .people-search__field {
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Users/Requests/Requests.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,sDAAsD;EACtD,wCAAwC;EACxC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;EACf,sDAAsD;EACtD,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,qEAAqE;AACvE;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8EAA8E;EAC9E,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,2CAA2C;EAC3C,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;AACV;;AAEA;;EAEE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,oCAAoC;EACpC,2CAA2C;EAC3C,kCAAkC;EAClC,mEAAmE;EACnE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wQAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,mDAAmD;EACnD,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,cAAc;EACd,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gFAAgF;EAChF,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,qCAAqC;EACrC,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,qCAAqC;EACrC,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,wCAAwC;EACxC,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sDAAsD;EACtD,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,wCAAwC;EACxC,8CAA8C;EAC9C,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,8FAA8F;EAC9F,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,mDAAmD;EACnD,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,gDAAgD;EAChD,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;EAC/C,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;;EAEE,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;EACX,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,+CAA+C;EAC/C,oCAAoC;EACpC,8CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA,iFAAiF;AACjF;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".requestsHub {\n  min-height: 100%;\n  padding: 0 4px 40px;\n  background: var(--surface-page, #f6f8fb);\n  color: var(--text-body, #334155);\n}\n\n.requestsHub-topbar {\n  min-height: 38px;\n  margin: -22px -24px 18px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--border-subtle, #dbe4ee);\n  background: var(--surface-card, #ffffff);\n  display: flex;\n  align-items: center;\n}\n\n.requestsHub-head {\n  min-height: 70px;\n  width: calc(100% + 56px);\n  margin: -20px 0 18px -28px;\n  padding: 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  display: flex;\n  align-items: center;\n  gap: 28px;\n}\n\n.requestsHub-breadcrumb {\n  margin-bottom: 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.requestsHub h1 {\n  margin: 0;\n  color: var(--text-heading, #0f172a);\n  font-family: var(--font-display, var(--font-body, system-ui, sans-serif));\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n  line-height: 1.15;\n}\n\n.requestsHub p {\n  max-width: 680px;\n  margin: 8px 0 18px;\n  color: var(--text-muted, #64748b);\n  font-size: var(--text-sm, 13px);\n  line-height: 1.55;\n  font-weight: 400;\n}\n\n.requestsHub-tabs {\n  min-width: 0;\n  margin: 0;\n  border: 0;\n  flex: 1;\n  display: flex;\n  align-self: stretch;\n  align-items: center;\n  gap: 26px;\n  overflow-x: auto;\n}\n\n.requestsHub-tab {\n  min-height: 70px;\n  padding: 24px 0 23px;\n  border-bottom: 3px solid transparent;\n  color: var(--text-muted, #64748b);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 650;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.requestsHub-tab:hover {\n  color: var(--brand-primary, #227ebd);\n  text-decoration: none;\n}\n\n.requestsHub-tab--active {\n  border-bottom-color: var(--blue-500, #227ebd);\n  color: var(--blue-600, #1a6da3);\n}\n\n.requestsHub-tab b {\n  min-width: 22px;\n  height: 22px;\n  padding: 0 7px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--slate-100, #eef2f6);\n  color: currentColor;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 850;\n  line-height: 1;\n}\n\n.requestsHub-tab--active b {\n  background: #e8f2fb;\n  color: var(--brand-primary, #227ebd);\n}\n\n.requestsHub-content > .mt-3 {\n  margin-top: 0 !important;\n}\n\n.requestsHub-content .requests-modernScreen {\n  gap: 12px;\n  padding: 12px 16px 0;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.requestsHub-content .requests-tableCard,\n.requestsHub-content .requests-empty {\n  border-right: 0;\n  border-left: 0;\n  border-bottom: 0;\n  border-radius: 0;\n}\n\n.requestsHub-content .people-pagination {\n  margin: 0 -16px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.requestsHub-content .row {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.requestsHub-content .col-md-12 {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n@media (max-width: 720px) {\n  .requestsHub {\n    padding: 0 4px 32px;\n  }\n\n  .requestsHub-head {\n    width: 100vw;\n    margin: -16px 0 14px -16px;\n    padding: 0 14px;\n    gap: 18px;\n  }\n\n  .requestsHub-tabs {\n    gap: 14px;\n    overflow-x: auto;\n  }\n\n  .requestsHub-tab {\n    flex: 0 0 auto;\n  }\n}\n\n.requests-modernScreen {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.requests-toolbar {\n  margin-bottom: 0;\n}\n\n.requests-toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.requests-toolbar__row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.requests-toolbar__row--primary {\n  justify-content: flex-start;\n  gap: 8px;\n}\n\n.requests-nameSearch {\n  width: min(360px, 100%);\n  margin: 0;\n  display: block;\n}\n\n.requests-nameSearch input {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font: 650 13px var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.requests-nameSearch input::placeholder {\n  color: var(--text-muted, #64748b);\n  font-weight: 400;\n  opacity: 1;\n}\n\n.requests-nameSearch input:focus {\n  outline: none;\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);\n}\n\n.requests-toolbar__row--secondary {\n  justify-content: flex-start;\n}\n\n.requests-toolbar__controls {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.requests-filter {\n  margin-top: 0;\n  grid-template-columns: repeat(2, minmax(160px, 1fr)) minmax(250px, 1.2fr) auto;\n  align-items: end;\n  gap: 16px;\n  padding: 16px;\n  border-color: var(--border-subtle, #dbe3ec);\n  background: var(--surface-subtle, #f8fafc);\n  box-shadow: none;\n  position: relative;\n  z-index: 20;\n  overflow: visible;\n}\n\n.requests-filter .people-filter__field {\n  min-width: 150px;\n  gap: 7px;\n}\n\n.requests-filter .people-filter__field > span,\n.requests-dateRange label {\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.requests-filter .people-filter__field input,\n.requests-filter .people-filter__field select {\n  width: 100%;\n  height: 38px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background-color: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.requests-filter .people-filter__field select {\n  padding-right: 36px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 11px center;\n  cursor: pointer;\n}\n\n.requests-filter .people-filter__field input:focus,\n.requests-filter .people-filter__field select:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));\n}\n\n.requests-dateRange {\n  min-width: 250px;\n  transform: translateY(-9px);\n  position: relative;\n  z-index: 30;\n}\n\n.requests-dateRange .sit-dp,\n.requests-dateRange .sit-dp__pop {\n  z-index: 10000;\n}\n\n.requests-dateRange .sit-dp__pop {\n  position: fixed;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n  overflow: hidden;\n  overscroll-behavior: contain;\n  align-items: stretch;\n  animation: none;\n}\n\n.requests-dateRange .sit-dp__pop > div:last-child {\n  min-width: 0;\n  min-height: 0;\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n}\n\n.requests-dateRange .sit-dp__pop > div:last-child > div:first-child {\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.requests-dateRange .sit-dp__pop > div:last-child > div:last-child {\n  flex: 0 0 auto;\n  padding: 0 14px 14px !important;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);\n}\n\n.requests-dateRange .sit-cal__foot {\n  position: static;\n  margin: 0;\n  padding-top: 12px;\n}\n\n.requests-filter .people-filter__actions {\n  min-height: 38px;\n  flex-wrap: nowrap;\n  transform: translateY(-9px);\n}\n\n.requests-filter .people-filter__actions .people-btn {\n  height: 38px;\n  min-height: 38px;\n}\n\n.requests-search {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(140px, 180px));\n  flex: 0 1 auto;\n  min-width: 0;\n  gap: 8px;\n}\n\n.requests-search .people-search__field {\n  width: auto;\n  min-width: 0;\n}\n\n.requests-search .people-search__field:first-child input {\n  border-radius: var(--radius-md, 8px);\n}\n\n.requests-search .people-search__field:last-child input {\n  border-radius: var(--radius-md, 8px);\n}\n\n@media (max-width: 900px) {\n  .requests-filter {\n    grid-template-columns: repeat(2, minmax(160px, 1fr));\n  }\n\n  .requests-filter .people-filter__actions {\n    transform: none;\n  }\n}\n\n.requests-selection {\n  margin-top: 0;\n}\n\n.requests-tableCard {\n  margin-top: 0;\n}\n\n.requests-table th,\n.requests-table td {\n  vertical-align: middle;\n}\n\n.requests-table th:first-child,\n.requests-table td:first-child {\n  width: 42px;\n}\n\n.requests-table--archive th:first-child,\n.requests-table--archive td:first-child {\n  width: auto;\n}\n\n.requests-table:not(.requests-table--archive).requests-hide-date th:nth-child(2),\n.requests-table:not(.requests-table--archive).requests-hide-date td:nth-child(2),\n.requests-table:not(.requests-table--archive).requests-hide-requester th:nth-child(3),\n.requests-table:not(.requests-table--archive).requests-hide-requester td:nth-child(3),\n.requests-table:not(.requests-table--archive).requests-hide-role th:nth-child(4),\n.requests-table:not(.requests-table--archive).requests-hide-role td:nth-child(4),\n.requests-table:not(.requests-table--archive).requests-hide-phone th:nth-child(5),\n.requests-table:not(.requests-table--archive).requests-hide-phone td:nth-child(5),\n.requests-table:not(.requests-table--archive).requests-hide-sports th:nth-child(6),\n.requests-table:not(.requests-table--archive).requests-hide-sports td:nth-child(6),\n.requests-table:not(.requests-table--archive).requests-hide-comment th:nth-child(7),\n.requests-table:not(.requests-table--archive).requests-hide-comment td:nth-child(7),\n.requests-table--archive.requests-hide-date th:nth-child(1),\n.requests-table--archive.requests-hide-date td:nth-child(1),\n.requests-table--archive.requests-hide-requester th:nth-child(2),\n.requests-table--archive.requests-hide-requester td:nth-child(2),\n.requests-table--archive.requests-hide-role th:nth-child(3),\n.requests-table--archive.requests-hide-role td:nth-child(3),\n.requests-table--archive.requests-hide-email th:nth-child(4),\n.requests-table--archive.requests-hide-email td:nth-child(4),\n.requests-table--archive.requests-hide-phone th:nth-child(5),\n.requests-table--archive.requests-hide-phone td:nth-child(5),\n.requests-table--archive.requests-hide-comment th:nth-child(6),\n.requests-table--archive.requests-hide-comment td:nth-child(6),\n.requests-table--archive.requests-hide-status th:nth-child(7),\n.requests-table--archive.requests-hide-status td:nth-child(7) {\n  display: none;\n}\n\n.requests-dateCell {\n  white-space: nowrap;\n  color: var(--text-body, #334155);\n  font-weight: 650;\n}\n\n.requests-personCell {\n  min-width: 220px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.requests-avatar {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #e8f2fb;\n  color: var(--brand-primary, #227ebd);\n  display: inline-grid;\n  place-items: center;\n  flex: 0 0 32px;\n  font-size: 11px;\n  font-weight: 850;\n  line-height: 1;\n  overflow: hidden;\n  text-align: center;\n}\n\n.requests-avatar > span,\n.requests-personCell .requests-avatar > span,\n.requestAcceptParent__student .requests-avatar > span {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  transform: none;\n  text-align: center;\n}\n.requests-personCell strong,\n.requests-personCell span {\n  display: block;\n}\n\n.requests-personCell strong {\n  color: var(--text-heading, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.requests-personCell div > span {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.requests-roleChip {\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  background: color-mix(in srgb, var(--requests-role-color, #227ebd) 13%, #ffffff);\n  color: var(--requests-role-color, #227ebd);\n  font-size: 12px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.requests-filter .people-filter__actions > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.requests-roleChip i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.requests-chipList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.requests-sportChip,\n.requests-moreChip {\n  min-height: 22px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--slate-100, #eef2f6);\n  color: var(--text-body, #334155);\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.requests-moreChip {\n  color: var(--text-muted, #64748b);\n}\n\n.requests-muted {\n  color: var(--text-subtle, #94a3b8);\n}\n\n.requests-contactCell,\n.requests-contactCell small {\n  display: block;\n}\n\n.requests-contactCell {\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.requests-contactCell small {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.requests-commentCell {\n  max-width: 280px;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--text-body, #334155);\n}\n\n.requests-statusBadge {\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--slate-100, #eef2f6);\n  color: var(--text-muted, #64748b);\n  display: inline-flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.requests-statusBadge--accepted {\n  background: #e8f7ee;\n  color: #268049;\n}\n\n.requests-statusBadge--rejected {\n  background: #fff4f2;\n  color: #b42318;\n}\n\n.requests-empty {\n  min-height: 260px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #ffffff);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  text-align: center;\n  padding: 32px;\n}\n\n.requests-empty__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: #e8f2fb;\n  color: var(--brand-primary, #227ebd);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 900;\n}\n\n.requests-empty h3 {\n  margin: 4px 0 0;\n  color: var(--text-heading, #0f172a);\n  font-size: 17px;\n  font-weight: 850;\n}\n\n.requests-empty p {\n  margin: 0;\n  max-width: 420px;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  font-weight: 550;\n}\n\n.requests-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.requests-pagination > div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.requests-pagination b {\n  color: var(--text-heading, #0f172a);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.requests-pagination .people-btn:disabled,\n.requests-selection .people-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .requests-filter .people-filter__field {\n    min-width: 100%;\n  }\n\n  .requests-pagination {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.requests-avatar--lg {\n  width: 44px;\n  height: 44px;\n  flex-basis: 44px;\n  font-size: 14px;\n}\n\n.requests-table tbody tr {\n  cursor: pointer;\n}\n\n.requests-table tbody tr[data-preview='true'] {\n  background: #eef8ff;\n}\n\n.requests-table tbody tr[data-preview='true'] td:first-child {\n  box-shadow: inset 3px 0 0 var(--brand-primary, #227ebd);\n}\n\n.requests-drawerScrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1030;\n  background: rgba(15, 23, 42, 0.18);\n}\n\n.requests-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1031;\n  width: min(440px, 100vw);\n  background: var(--surface-card, #ffffff);\n  box-shadow: -22px 0 48px rgba(15, 23, 42, 0.18);\n  display: flex;\n  flex-direction: column;\n}\n\n.requests-drawer__head {\n  padding: 22px 22px 18px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.requests-drawer__identity {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.requests-drawer__identity h2 {\n  margin: 0;\n  color: var(--text-heading, #0f172a);\n  font-size: 18px;\n  font-weight: 850;\n  line-height: 1.2;\n}\n\n.requests-drawer__identity p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.requests-drawer__close {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-subtle, #dbe4ee);\n  border-radius: var(--radius-md, 8px);\n  background: #ffffff;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  font-size: 22px;\n  line-height: 1;\n}\n\n.requests-drawer__body {\n  padding: 18px 22px;\n  overflow: auto;\n  flex: 1;\n}\n\n.requests-drawerSection {\n  padding: 0 0 18px;\n  margin-bottom: 18px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.requests-drawerSection:last-child {\n  margin-bottom: 0;\n}\n\n.requests-drawerSection__title,\n.requests-drawerField span {\n  margin-bottom: 9px;\n  color: var(--text-muted, #64748b);\n  display: block;\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.requests-drawerField {\n  margin-top: 12px;\n}\n\n.requests-drawerField strong {\n  color: var(--text-heading, #0f172a);\n  display: block;\n  font-size: 14px;\n  font-weight: 750;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.requests-drawerMessage {\n  padding: 13px 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--slate-25, #fbfdff);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.55;\n}\n\n.requests-drawer__foot {\n  padding: 14px 18px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 720px) {\n  .requestsHub-topbar {\n    margin: -18px -14px 16px;\n    padding: 0 14px;\n  }\n}\n\n.requestActionModal {\n  border: 0;\n  border-radius: var(--radius-lg, 12px);\n  overflow: hidden;\n  background: var(--surface-card, #ffffff);\n  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.requestActionModal--embedded {\n  margin: -22px -24px;\n  box-shadow: none;\n}\n\n.requestActionModal__dialog {\n  margin: 24px auto;\n}\n\n.requestActionModal__head {\n  padding: 20px 22px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 13px;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n}\n\n.requestActionModal__head h5 {\n  margin: 0;\n  color: var(--text-heading, #0f172a);\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  font-size: 19px;\n  font-weight: 850;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.requestActionModal__head p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n.requestActionModal__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-md, 8px);\n  background: #e8f2fb;\n  color: var(--brand-primary, #227ebd);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.requestActionModal__icon--warning {\n  background: #fff7e8;\n  color: #b76b00;\n}\n\n.requestActionModal__icon--danger {\n  background: #fff1f2;\n  color: var(--red-600, #c4313f);\n}\n\n.requestActionModal__close {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-subtle, #dbe4ee);\n  border-radius: var(--radius-md, 8px);\n  background: #ffffff;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  font-size: 22px;\n  line-height: 1;\n  padding: 0;\n}\n\n.requestActionModal__body {\n  padding: 22px;\n  color: var(--text-body, #334155);\n  font-size: 14px;\n  font-weight: 550;\n  line-height: 1.55;\n}\n\n.requestActionModal__body p {\n  display: block;\n  width: 100%;\n  max-width: none;\n  margin: 0 0 16px;\n  color: var(--text-body, #334155);\n  font-size: 14px;\n  font-weight: 550;\n}\n\n.requestActionModal__intro {\n  grid-column: 1 / -1;\n  align-self: stretch;\n}\n\n.requestRejectModal .modal-body {\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.requestRejectModal .requestActionModal--embedded {\n  margin: 0;\n}\n\n.requestRejectModal .requestActionModal__head {\n  padding: 15px 17px;\n}\n\n.requestRejectModal .requestActionModal__head h5 {\n  font-size: 17px;\n}\n\n.requestRejectModal .requestActionModal__head p {\n  margin-top: 3px;\n  font-size: 12px;\n}\n\n.requestRejectModal .requestActionModal__icon {\n  width: 34px;\n  height: 34px;\n}\n\n.requestRejectModal .requestActionModal__body {\n  padding: 15px 17px;\n}\n\n.requestRejectModal .requestActionModal__notice {\n  padding: 11px 12px;\n  font-size: 12.5px;\n}\n\n.requestRejectModal .requestActionModal__foot {\n  padding: 11px 17px;\n}\n\n.requestActionModal__identityGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.requestActionModal__identityGrid > div,\n.requestActionModal__summaryCard {\n  padding: 13px 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--slate-25, #fbfdff);\n}\n\n.requestActionModal__identityGrid span,\n.requestActionModal__summaryCard span {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.requestActionModal__identityGrid strong,\n.requestActionModal__summaryCard strong {\n  display: block;\n  color: var(--text-heading, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.requestActionModal__summaryCard small {\n  display: block;\n  margin-top: 3px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.requestActionModal__summaryArrow {\n  margin: 10px 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.requestActionModal__notice {\n  padding: 13px 14px;\n  border: 1px solid #ffe3ad;\n  border-radius: var(--radius-md, 8px);\n  background: #fffaf0;\n  color: #755100;\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.5;\n}\n\n.requestActionModal__notice--danger {\n  border-color: #ffd5da;\n  background: #fff5f6;\n  color: #9f2430;\n}\n\n.requestActionModal__foot,\n.requestMergeForm__foot,\n.requestAcceptParent__foot {\n  padding: 16px 22px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  flex-wrap: wrap;\n  background: #fbfdff;\n}\n\n.requestMergeForm {\n  margin: -22px -24px;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.requestMergeForm__head {\n  padding: 20px 22px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  display: flex;\n  align-items: center;\n  gap: 13px;\n}\n\n.requestMergeForm__head h5 {\n  margin: 0;\n  color: var(--text-heading, #0f172a);\n  font-size: 19px;\n  font-weight: 850;\n  line-height: 1.2;\n}\n\n.requestMergeForm__head p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.requestMergeForm__grid {\n  padding: 18px 22px 0;\n  display: grid;\n  gap: 12px;\n}\n\n.requestMergeForm__grid--two {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.requestMergeForm__field {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 7px;\n  margin: 0;\n}\n\n.requestMergeForm__field > span {\n  color: var(--text-heading, #0f172a);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.requestMergeForm > .requestMergeForm__field {\n  padding: 18px 22px 22px;\n}\n\n.requestMergeForm__autocomplete {\n  width: 100%;\n}\n\n.requestMergeForm__autocomplete input,\n.requestAcceptParent .eAutocomplete input {\n  min-height: var(--control-h-md, 40px);\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  color: var(--text-heading, #0f172a);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.requestAcceptParent {\n  padding: 24px;\n  min-height: 100%;\n  background: var(--surface-page, #f6f8fb);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.requestAcceptParent__card {\n  max-width: 980px;\n  margin: 0 auto;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #ffffff);\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.requestAcceptParent__head {\n  padding: 22px 24px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  display: flex;\n  align-items: center;\n  gap: 13px;\n}\n\n.requestAcceptParent__head h1 {\n  margin: 0;\n  color: var(--text-heading, #0f172a);\n  font-size: 24px;\n  font-weight: 850;\n  line-height: 1.15;\n}\n\n.requestAcceptParent__head p {\n  margin: 5px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.requestAcceptParent__message {\n  margin: 18px 24px 0;\n  padding: 13px 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: #fbfdff;\n}\n\n.requestAcceptParent__message span,\n.requestAcceptParent__sectionTitle {\n  display: block;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 850;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.requestAcceptParent__message strong {\n  display: block;\n  margin-top: 6px;\n  color: var(--text-heading, #0f172a);\n  font-size: 14px;\n  font-weight: 650;\n  line-height: 1.45;\n}\n\n.requestAcceptParent__details {\n  margin: 18px 24px 0;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.requestAcceptParent__details > div {\n  padding: 12px 13px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: #fbfdff;\n}\n\n.requestAcceptParent__details span {\n  display: block;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.requestAcceptParent__details strong {\n  display: block;\n  margin-top: 4px;\n  color: var(--text-heading, #0f172a);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.requestAcceptParent__sectionTitle {\n  margin: 20px 24px 10px;\n}\n\n.requestAcceptParent__grid {\n  margin: 0 24px;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.requestAcceptParent__error {\n  margin: 14px 24px 0;\n  padding: 12px 13px;\n  border: 1px solid #ffd5da;\n  border-radius: var(--radius-md, 8px);\n  background: #fff5f6;\n  color: #9f2430;\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.requestAcceptParent__studentGrid {\n  margin: 0 24px;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.requestAcceptParent__student {\n  min-width: 0;\n  padding: 10px 11px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: #ffffff;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.requestAcceptParent__student:hover,\n.requestAcceptParent__student--selected {\n  border-color: var(--border-brand, #6fb1df);\n  background: #eef8ff;\n  text-decoration: none;\n}\n\n.requestAcceptParent__student strong,\n.requestAcceptParent__student small {\n  display: block;\n}\n\n.requestAcceptParent__student strong {\n  color: var(--text-heading, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.requestAcceptParent__student small {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.requestAcceptParent__foot {\n  margin-top: 22px;\n}\n\n@media (max-width: 780px) {\n  .requestActionModal__identityGrid,\n  .requestMergeForm__grid--two,\n  .requestAcceptParent__details,\n  .requestAcceptParent__grid,\n  .requestAcceptParent__studentGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .requestAcceptParent {\n    padding: 14px;\n  }\n}\n\n.requestMergeForm__autocomplete.bAutocomplete,\n.requestAcceptParent .requestMergeForm__autocomplete.bAutocomplete {\n  display: block;\n  width: 100%;\n}\n\n.requestMergeForm__autocomplete .eShowDropdownMenu,\n.requestAcceptParent .requestMergeForm__autocomplete .eShowDropdownMenu {\n  position: static !important;\n  float: none;\n  transform: none !important;\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  max-height: 220px;\n  margin-top: 6px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.requestAcceptParent__card {\n  overflow: visible;\n}\n/* Role-request lists have few fields, so the handoff uses an anchored popover. */\n.requests-modernScreen,\n.requests-page {\n  position: relative;\n}\n\n.requests-filter.people-filter {\n  position: fixed;\n  z-index: 1050;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  height: auto;\n  max-height: none;\n  align-items: stretch;\n  gap: 10px;\n  margin: 0;\n  padding: 18px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  border: 0;\n  border-left: 1px solid #d9e2ec;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.requests-filterScrim {\n  position: fixed;\n  inset: 0;\n  z-index: 1049;\n  background: rgba(15, 23, 42, 0.18);\n}\n\n.requests-contentLayout {\n  min-width: 0;\n}\n\n.requests-contentLayout--withFilter {\n  display: block;\n}\n\n.requests-contentMain {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.requests-filter .people-filter__header {\n  margin-bottom: 2px;\n}\n\n.requests-filter .requests-dateRange {\n  width: 100%;\n  min-width: 0;\n  transform: none;\n}\n\n.requests-filter .people-chipFilter legend {\n  margin-bottom: 5px;\n}\n\n.requests-filter .people-chipFilter__body {\n  max-height: none;\n  overflow: visible;\n}\n\n.requests-filter .people-chipFilter__chips {\n  gap: 5px;\n}\n\n.requests-filter .people-chipFilter__chip {\n  min-height: 27px;\n  padding: 3px 8px;\n  font-size: 11px;\n}\n\n.requests-filter .people-filter__actions {\n  position: static;\n  width: auto;\n  max-width: none;\n  min-height: auto;\n  margin: auto 0 0;\n  padding: 14px 0 0;\n  border-top: 1px solid #e6ebf1;\n  transform: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.requests-filter .people-filter__actions .people-btn {\n  height: 38px;\n  min-height: 38px;\n}\n\n@media (max-width: 640px) {\n  .requests-contentLayout--withFilter {\n    display: block;\n  }\n\n  .requests-filter.people-filter {\n    position: fixed;\n    top: auto;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    max-height: 86vh;\n    overflow-y: auto;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .requests-toolbar__row--primary {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .requests-toolbar__row--secondary,\n  .requests-search {\n    width: 100%;\n  }\n\n  .requests-search {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .requests-search .people-search__field {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
